import { render, staticRenderFns } from "./grlist.vue?vue&type=template&id=6d4fb478"
import script from "./grlist.vue?vue&type=script&lang=js"
export * from "./grlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports